/*  ========================================================================
    # Hooks - Use Tab Visible
    ========================================================================  */

import { useCallback, useEffect, useState } from 'react';

export default function useTabVisible() {
  const [visible, setVisible] = useState(true);

  // Update visibility state based on the documents visibility state
  const handleVisibilityChange = useCallback(() => {
    setVisible(document.visibilityState === 'visible');
  }, []);

  // Add handler for the visibility change of the document
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  // Return boolean value to determine whether the window is visible or not
  return visible;
}
